<template>
  <section class="invoice-preview-wrapper">

    <!-- Alert: No item found -->
    <b-alert
      variant="danger"
      :show="invoiceData === undefined"
    >
      <h4 class="alert-heading">
        Error fetching invoice data
      </h4>
      <div class="alert-body">
        No invoice found with this invoice id. Check
        <b-link
          class="alert-link"
          :to="{ name: 'apps-invoices-list'}"
        >
          Invoice List
        </b-link>
        for other invoices.
      </div>
    </b-alert>

    <b-row
      v-if="invoiceData"
      class="invoice-preview"
    >

      <!-- Col: Left (Invoice Container) -->
      <b-col
        cols="12"
        xl="9"
        md="8"
      >
        <b-card
          ref="payrollPreviewRef"
          no-body
          class="invoice-preview-card"
        >
          <!-- Header -->
          <b-card-body class="invoice-padding pb-0">

            <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">

              <!-- Header: Left Content -->
              <div>
                <div class="logo-wrapper">
                  <span class="brand-logo">
                    <b-img
                      :src="require(`@hw-ui/assets/images/logo/${this.$store.state.app.appConfig.logoName}`)"
                      style="width: 50px"
                      alt="logo"
                    />
                  </span>
                  <h3
                    class="invoice-logo"
                  >
                    {{ this.$store.state.app.appConfig.name }}
                  </h3>
                </div>
                <p class="card-text mb-25">
                  {{ bankDetails.address.streetAddress }}
                </p>
                <p class="card-text mb-25">
                  {{ bankDetails.address.postcode }} {{ bankDetails.address.city }}
                </p>
                <p class="card-text mb-0">
                  {{ bankDetails.contact }}
                </p>
                <p class="card-text mb-0">
                  Y-Tunnus: {{ bankDetails.YTunnus }}
                </p>
                <p class="card-text mb-0">
                  ALV-Numero: {{ bankDetails.YTunnus }}
                </p>
              </div>

              <!-- Header: Right Content -->
              <div class="mt-md-2 mt-2">
                <h4 class="invoice-title">
                  Laskuerittely
                </h4>
                <div class="invoice-date-wrapper">
                  <p
                    class="invoice-date-title"
                    style="width: 12rem"
                  >
                    Laskun päiväys:
                  </p>
                  <p class="invoice-date">
                    {{ invoiceData.date.toDate().toLocaleDateString('fi') }}
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p
                    class="invoice-date-title"
                    style="width: 12rem"
                  >
                    Toimituspäivämäärä:
                  </p>
                  <p class="invoice-date">
                    {{ invoiceData.date.toDate().toLocaleDateString('fi') }}
                  </p>
                </div>
                <div class="invoice-date-wrapper">
                  <p
                    class="invoice-date-title"
                    style="width: 12rem"
                  >
                    Eräpäivä:
                  </p>
                  <p class="invoice-date">
                    {{ invoiceData.dueDate.toDate().toLocaleDateString('fi') }}
                  </p>
                </div>
              </div>
            </div>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing">

          <!-- Invoice Client & Payment Details -->
          <b-card-body
            v-if="invoiceData.client"
            class="invoice-padding pt-0"
          >
            <b-row class="invoice-spacing">

              <!-- Col: Invoice To -->
              <b-col
                cols="12"
                xl="6"
                class="p-0"
              >
                <h6 class="mb-25">
                  {{ invoiceData.client.name }}
                </h6>
                <p class="card-text mb-25">
                  {{ invoiceData.client.contact }}
                </p>
              </b-col>

              <!-- Col: Payment Details -->
              <b-col
                xl="6"
                cols="12"
                class="p-0 mt-xl-0 mt-2 d-flex justify-content-xl-end"
              >
                <!-- <div>
                  <h6 class="mb-2">
                    MAKSUTIEDOT:
                  </h6>
                  <table>
                    <tbody>
                      <tr>
                        <td class="pr-1">
                          Nimi:
                        </td>
                        <td>{{ bankDetails.name }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          IBAN:
                        </td>
                        <td>{{ bankDetails.IBAN }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          BIC:
                        </td>
                        <td>{{ bankDetails.BIC }}</td>
                      </tr>
                      <tr>
                        <td class="pr-1">
                          Pankki:
                        </td>
                        <td>{{ bankDetails.bankName }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div> -->
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Invoice Description: Table -->
          <b-table-lite
            responsive
            sticky-header
            :items="invoiceData.items"
            :fields="[{ key: 'title', label: 'Työntekijä/Pvm'}, { key: 'qty', label: 'Määrä'}, { key: 'unit', label: 'Yksikkö'}, { key: 'cost', label: 'Hinta'}, { key: 'total', label: 'Yhteensä'}]"
          >
            <template #cell(qty)="data">
              <b-card-text class="mb-25">
                {{ parseFloat(data.item.qty).toFixed(2) }}
              </b-card-text>
            </template>
            <template #cell(cost)="data">
              <b-card-text class="mb-25">
                {{ parseFloat(data.item.cost ? data.item.cost : 0).toFixed(2) }} €
              </b-card-text>
            </template>
            <template #cell(total)="data">
              <b-card-text class="mb-25">
                {{ parseFloat(data.item.total).toFixed(2) }} €
              </b-card-text>
            </template>
          </b-table-lite>
          <!-- Spacer -->
          <hr class="invoice-spacing">
          <!-- Invoice Description: Total -->
          <b-card-body class="invoice-padding pb-0">
            <b-row>

              <!-- Col: Sales Persion -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-0 mt-3"
                order="2"
                order-md="1"
              />
              <!-- Col: Total -->
              <b-col
                cols="12"
                md="6"
                class="mt-md-6 d-flex justify-content-end"
                order="1"
                order-md="2"
              >
                <div class="invoice-total-wrapper">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Yhteensä veroton:
                    </p>
                    <p class="invoice-total-amount">
                      {{ parseFloat(invoiceData.total).toFixed(2) }} €
                    </p>
                  </div>
                  <hr class="my-50">
                  <div class="invoice-total-item">
                    <p class="invoice-total-title">
                      Yhteensä:
                    </p>
                    <p class="invoice-total-amount">
                      {{ parseFloat(invoiceData.total).toFixed(2) }} €
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-card-body>

          <!-- Spacer -->
          <hr class="invoice-spacing">

        </b-card>
      </b-col>

      <!-- Right Col: Card -->
      <b-col
        cols="12"
        md="4"
        xl="3"
        class="invoice-actions"
      >
        <b-card>
          <!-- Button: Print -->
          <!-- <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="primary"
            class="mb-75"
            block
            @click="printInvoice"
          >
            Print
          </b-button> -->

          <!-- Button: Edit -->
          <!-- Button: Download -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            :disabled="downloading"
            variant="primary"
            class="mb-75"
            block
            @click="downloadInvoice(invoiceData)"
          >
            <b-spinner
              v-if="downloading"
              small
            />
            <span
              v-if="!downloading"
            >
              Tulosta
            </span>
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-primary"
            class="mb-75"
            block
            :to="{ name: 'apps-invoices-edit', params: { id: $route.params.id } }"
          >
            Muokkaa
          </b-button>
          <!-- Button: DOwnload -->
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            class="mb-75"
            block
            :to="{ name: 'apps-invoices-list' }"
          >
            Sulje
          </b-button>
        </b-card>
      </b-col>
    </b-row>

    <invoice-sidebar-send-invoice />
    <invoice-sidebar-add-payment />
  </section>
</template>

<script>
import { ref } from '@vue/composition-api'
import store from '@/shared/store'
// eslint-disable-next-line import/no-cycle
import router from '@/shared/router'
import {
  BRow, BCol, BCard, BCardBody, BTableLite, BCardText, BButton, BAlert, BLink, VBToggle,
  BImg, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { downloadInvoice } from '@/shared/services/invoiceService'
import InvoiceSidebarSendInvoice from '../InvoiceSidebarSendInvoice.vue'
import InvoiceSidebarAddPayment from '../InvoiceSidebarAddPayment.vue'

export default {
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    BSpinner,

    BImg,
    InvoiceSidebarAddPayment,
    InvoiceSidebarSendInvoice,
  },
  setup() {
    const invoiceData = ref(null)
    const downloading = ref(false)
    const payrollPreviewRef = ref(null)

    store.dispatch('appInvoice/fetchInvoice', { id: router.currentRoute.params.id })
      .then(response => {
        invoiceData.value = response
      })
      .catch(error => {
        if (error.response.status === 404) {
          invoiceData.value = undefined
        }
      })
    const bankDetails = ref({ address: {} })
    store.dispatch('appInvoice/fetchBankDetails')
      .then(response => { bankDetails.value = response.data })

    const printInvoice = () => {
      window.print()
    }

    return {
      downloading,
      invoiceData,
      printInvoice,
      bankDetails,
      payrollPreviewRef,
      downloadInvoice,
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@hw-ui/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {

  // Global Styles
  body {
    background-color: transparent !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
  }
  .customizer-toggle {
    display: none !important;
  }

  // Invoice Specific Styles
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
              > .col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    // Action Right Col
    .invoice-actions {
      display: none;
    }
  }
}
</style>
